import { render, staticRenderFns } from "./PrintTail.vue?vue&type=template&id=986913d8&scoped=true&"
import script from "./PrintTail.vue?vue&type=script&lang=ts&"
export * from "./PrintTail.vue?vue&type=script&lang=ts&"
import style0 from "./PrintTail.vue?vue&type=style&index=0&id=986913d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986913d8",
  null
  
)

export default component.exports